import { render, staticRenderFns } from "./joinChannel.vue?vue&type=template&id=9570110c&scoped=true&"
import script from "./joinChannel.vue?vue&type=script&lang=js&"
export * from "./joinChannel.vue?vue&type=script&lang=js&"
import style0 from "./joinChannel.vue?vue&type=style&index=0&id=9570110c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9570110c",
  null
  
)

export default component.exports